// extracted by mini-css-extract-plugin
export default {"wrapper":"CaptureVisa_style_wrapper__Lq1UQ","rotate":"CaptureVisa_style_rotate__9w3D1"};